import React, { useState, useEffect } from "react";
import Modal from "./Modal";

export default function Search() {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    // scroll to top of page when modal opens
    if (openModal) {
      window.scrollTo(0, 0);
    }
    document.body.classList.toggle("search-open", openModal);
  }, [openModal]);

  return (
    <div className="search">
      <button
        className="search-toggle"
        onClick={() => setOpenModal(!openModal)}
      >
        Search
      </button>
      <Modal openModal={openModal} setOpenModal={setOpenModal} />
    </div>
  );
}
